import { render, staticRenderFns } from "./AlertsIndex.vue?vue&type=template&id=6605484c&"
import script from "./AlertsIndex.vue?vue&type=script&lang=js&"
export * from "./AlertsIndex.vue?vue&type=script&lang=js&"
import style0 from "./AlertsIndex.vue?vue&type=style&index=0&id=6605484c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports